import { Routes } from '@angular/router';
import { PLANNING_ROUTES_WITH_PERMISSIONS } from './app.routes';

export default PLANNING_ROUTES_WITH_PERMISSIONS satisfies Routes;